import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CountdownTimer from 'Components/Utility/CountdownTimer';

import 'Components/StarDeal/StarDealCountdown.scss';

const StarDealCountdown = ({
  soldOut,
  currentDiscount,
  keysAvailablePercentage,
}) => {
  const styling = {
    keys: {
      width: `${keysAvailablePercentage}%`,
    },
  };

  return (
    <div className="StarDealCountdown">
      <div className="keys-container">
        <small className="float-right">0%</small>
        <div className="progress">
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            style={!soldOut ? styling.keys : { width: '0%' }}
            aria-valuenow={!soldOut ? keysAvailablePercentage : 0}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label="Keys remaining"
            title="Keys remaining"
          />
          {keysAvailablePercentage >= 85 &&
            <div className="progress-timer progress-timer-overlay">
              {keysAvailablePercentage}% &nbsp;<FormattedMessage id="stardealcountdown.remaininghigh" defaultMessage="Remaining" tagName="span" />
            </div>
          }
          {keysAvailablePercentage < 85 && keysAvailablePercentage >= 20 &&
            <div className="progress-timer progress-timer-overlay">
              {keysAvailablePercentage}% &nbsp;<FormattedMessage id="stardealcountdown.remaining" defaultMessage="keys left" tagName="span" />
            </div>
          }
          {keysAvailablePercentage < 20 &&
            <div className="remaining-keys progress-timer progress-timer-overlay">
              <span className="d-none d-lg-block"><FormattedMessage id="stardealcountdown.remaininglow" defaultMessage="Last Few Keys Remaining" tagName="span" /></span>
              <span className="d-none d-md-block d-lg-none"><FormattedMessage id="stardealcountdown.remaininglowsmall" defaultMessage="Last Few Keys" tagName="span" /></span>
            </div>
          }
        </div>
        <small className="float-right">100%</small>
      </div>

      <CountdownTimer featuredDeal value={Date.parse(currentDiscount.until)} />
    </div>
  );
};

StarDealCountdown.propTypes = {
  soldOut: PropTypes.bool,
  currentDiscount: PropTypes.shape({}),
  keysAvailablePercentage: PropTypes.number,
};

StarDealCountdown.defaultProps = {
  soldOut: false,
  currentDiscount: null,
  keysAvailablePercentage: 0,
};

export default StarDealCountdown;
